// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { DevTypes, Environment } from '@bepatient/core';

export const environment: Environment = {
  production: false,
  devType: DevTypes.DEV,
  version: '1.38.0',
  useEncryption: true,
  instancesData: {
    dev: {
      url: 'https://dev-smart-webservice.bepatientsolutions.com',
      code: ''
    },
    prod: {
      url: 'https://smart-webservice.bepatientsolutions.com',
      code: ''
    }
  },
  appStoreLinks: {
    ios: 'https://beta.itunes.apple.com/v1/app/1601154091',
    android:
      'https://play.google.com/store/apps/details?id=com.bepatient.smartapp&ah=mpb7XkhY1YrU7vLK11BqsOYGXmw'
  },
  supportedDevices: ['hs4s', 'hs3', 'bp5', 'po3', 'shine2'],
  privacyStatementUrl: 'https://b-research-privacy.banookgroup.com'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
